import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled, { css } from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

interface TableTimestampProps {
  align?: 'left' | 'right';
  date: string;
  time?: string;
  isLoading?: boolean;
  className?: string;
}

const Layout = styled.div<Partial<TableTimestampProps>>`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-end;
  width: auto;
  height: ${toRem(theme.table.cell.height)};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  color: ${theme.color.neutral[900]};

  @media (min-width: ${theme.breakpoint.small}px) {
    align-items: flex-start;
  }

  ${({ align }) =>
    align === 'left' &&
    css`
      align-items: flex-start;
    `}
`;

const Date = styled.span`
  position: relative;
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
`;

const Time = styled.span`
  position: relative;
  margin-top: ${toRem(theme.space.xs)};
  font-size: ${toRem(theme.font.size.xxs)};
  line-height: ${lineHeight(theme.font.size.xxs)};
  color: ${theme.color.neutral[500]};
`;

const TableTimestamp = ({ align, date, time, isLoading, className }: TableTimestampProps) => (
  <Layout align={align} className={className}>
    {isLoading ? <Skeleton width={60} /> : <Date>{date}</Date>}
    {time && <Time>{isLoading ? <Skeleton width={40} /> : time}</Time>}
  </Layout>
);

export default TableTimestamp;
